export default [
  { label: 'Season', key: 'season' },
  { label: 'NO', key: 'no' },
  { label: 'EventName', key: 'eventName' },
  { label: 'TeamName', key: 'teamName' },
  { label: 'Team', key: 'team' },
  { label: 'Bkr', key: 'bkr' },
  { label: 'Total', key: 'total' },
  { label: 'Gm', key: 'gm' },
  { label: 'Avg', key: 'avg' },
  { label: 'Diff', key: 'diff' },
  { label: 'Division', key: 'division' },
  { label: 'Varsity', key: 'varsity' },
  { label: 'GamesBowled', key: 'gamesBowled' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/standingsByEventHeaders.js